import i18n from "i18next"
// import HttpBackend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector"
import { initReactI18next } from "react-i18next"

// const apiKey = "zAIofh6b_RGe6K4rSBKnYA";
// const loadPath = `https://api.i18nexus.com/project_resources/translations/{{lng}}/{{ns}}.json?api_key=${apiKey}`;

import localeRU from "../locales/ru/ru.json"
import localeRUClient from "../locales/ru/client.json"

// const apiKey = "e7W6Kwz9dJPg31Xsywyi3w";
// const loadPath = `https://api.i18nexus.com/project_resources/translations/{{lng}}/{{ns}}.json?api_key=${apiKey}`;

const resources = {
  ru: {
    translation: localeRU,
    client: { ...localeRU, ...localeRUClient },
  },
}

i18n
  // .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: "ru",

    // ns: ["default"],
    // defaultNS: "default",

    supportedLngs: ["ru"],
    fallbackLng: ["ru"],
    saveMissing: true,

    // backend: {
    //   loadPath: loadPath,
    // },
  })

i18n.on("missingKey", function (lngs, namespace, key, res) {
  // console.log({ lngs, namespace, key, res })
})

export default i18n
